type WithRequiredProperty = {
  required: boolean
}

export function sortByRequired(
  a: WithRequiredProperty,
  b: WithRequiredProperty,
) {
  return a.required && !b.required ? -1 : 1
}
